import Vue from 'vue';
import VueRouter from 'vue-router';
import { GetCookie } from '../utils/Cookie';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: '/',
  },
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/esqueci-senha',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPassword.vue'),
  },
  {
    path: '/forgot-password/:token',
    name: 'ConfirmPassword',
    component: () => import('../views/ConfirmPassword.vue'),
  },
  {
    path: '/produtos',
    name: 'Produtos',
    component: () => import('../views/Produtos.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/casas',
    name: 'Casas',
    component: () => import('../components/house/Houses.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/colheita',
    name: 'Colheita',
    component: () => import('../views/Harvest.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/clientes',
    name: 'Clientes',
    component: () => import('../views/Client.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/novo-cliente',
    name: 'Novo-Cliente',
    component: () => import('../views/NewClient.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/clientes/:clientId',
    name: 'Editar-Cliente',
    component: () => import('../views/EditClient.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/vendas',
    name: 'Vendas',
    component: () => import('../views/Sale.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/nova-venda',
    name: 'Nova-Venda',
    component: () => import('../components/sale/NewSale.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/vendas/:saleId',
    name: 'Editar-Venda',
    component: () => import('../components/sale/EditSale.vue'),
  },
  {
    path: '/composto',
    name: 'Composto',
    component: () => import('../views/Compound.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/novo-composto',
    name: 'Novo Composto',
    component: () => import('../views/NewCompound.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/composto/:compostoId',
    name: 'Editar Composto',
    component: () => import('../views/EditCompound.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/configuracoes',
    name: 'Configuracoes',
    component: () => import('../views/Settings.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/confirm-register/:token',
    name: 'Confirm-User',
    component: () => import('../views/Confirm.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (GetCookie('token')) next();
    else next('/');
  } else next();
});

export default router;
